import { render, staticRenderFns } from "./purchase-plan-detail.vue?vue&type=template&id=614de4ef&scoped=true&"
import script from "./purchase-plan-detail.vue?vue&type=script&lang=js&"
export * from "./purchase-plan-detail.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan-detail.vue?vue&type=style&index=0&id=614de4ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614de4ef",
  null
  
)

export default component.exports